module.exports = __webpack_public_path__ + "media/bipopen.32194199.mp3";